import { render, staticRenderFns } from "./FooterTabel.vue?vue&type=template&id=143bf372&scoped=true"
import script from "./FooterTabel.vue?vue&type=script&lang=js"
export * from "./FooterTabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143bf372",
  null
  
)

export default component.exports